import React from 'react';
import {
  Box,
  ColorTokenName,
  Icon,
  IconSource,
} from '@clariness/clarikit-react';

type NavBarItemLabelProps = {
  icon: IconSource;
  color: ColorTokenName;
  label: string;
};

export const NavBarItemLabel: React.FC<NavBarItemLabelProps> = ({
  icon,
  color,
  label,
}) => (
  // Clarikit Link renders medium/bold text; nav items use the regular weight.
  <Box
    as="span"
    display="inline-flex"
    alignItems="center"
    gap="5px"
    style={{ fontWeight: 'normal', whiteSpace: 'nowrap' }}
  >
    <Icon source={icon} size="small" color={color} accessibilityLabel="" />
    {/* Hidden below md; the parent link's aria-label keeps its accessible name. */}
    <Box as="span" display={{ _: 'none', md: 'inline' }} aria-hidden="true">
      {label}
    </Box>
  </Box>
);
